import React from 'react';

const InstagramIcon = ({ size = 24, strokeWidth = 2, color = "currentColor", className = "" }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        className={className}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        {/* Main square rounded body */}
        <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
        
        {/* Inner circle (the lens) */}
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
        
        {/* Top-right dot (the flash) */}
        <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
    </svg>
);

export default InstagramIcon;